import { useCallback } from "react";
import { ServiceEnvironment } from "Enums/ServiceEnvironment";
import { CentralAdminEntityType } from "Enums/CentralAdminEntityType";
import { ScopeItem } from "Shared/Components/Scope/Scopes.types";
import { centralAdminCapacityUnitSchemaFromTopologyService } from "../CentralAdminTopology";
import { useORPCClient } from "Core/oRPC";

export const useSubstrateCapacityUnit = () => {
    const orpcClient = useORPCClient();

    const getCapacityUnitList = useCallback(
        async (env?: ServiceEnvironment, workload?: string, selectedScopesSoFar?: ScopeItem[]): Promise<ScopeItem[]> => {
            const selectedFaultZone = selectedScopesSoFar?.find((scope) => scope.ScopeType?.toLowerCase() === "faultzone");
            const selectedLocation = selectedScopesSoFar?.find((scope) => scope.ScopeType?.toLowerCase() === "location");
            const selectedForest = selectedScopesSoFar?.find((scope) => scope.ScopeType?.toLowerCase() === "forest");

            let filterType: CentralAdminEntityType | undefined;
            let filterValue: string | undefined;

            const isFaultZoneAll = selectedFaultZone?.Value?.toLowerCase() === "all";
            if (selectedFaultZone && !isFaultZoneAll) {
                filterType = CentralAdminEntityType.FaultZone;
                filterValue = selectedFaultZone.Value?.toUpperCase();
            } else if (selectedLocation) {
                filterType = CentralAdminEntityType.Location;
                filterValue = selectedLocation.Value?.toUpperCase();
            } else if (selectedForest) {
                filterType = CentralAdminEntityType.Forest;
                filterValue = selectedForest.Value?.toUpperCase();
            }

            if (!filterType || !filterValue) {
                return [];
            }

            const capacityUnitRequest = {
                Environment: env,
                Workload: workload || "",
                TargetType: CentralAdminEntityType.CapacityUnit,
                FilterType: filterType,
                FilterValue: filterValue
            };

            const capacityUnitOutput = await orpcClient.inventoryApi.postTopology(capacityUnitRequest);
            const capacityUnitParsedOutput = centralAdminCapacityUnitSchemaFromTopologyService.array().parse(capacityUnitOutput);
            return capacityUnitParsedOutput
                .filter(
                    (item) =>
                        item.ActivityState &&
                        item.ActivityState.toLowerCase() !== "decom" &&
                        item.ProvisioningState &&
                        item.ProvisioningState.toLowerCase() !== "retired"
                )
                .map((item) => ({
                    ScopeType: "CapacityUnit",
                    Value: item.Name ?? ""
                }));
        },
        [orpcClient]
    );

    return {
        getCapacityUnitList
    };
};
